import { render, staticRenderFns } from "./bRadioInputValidation.vue?vue&type=template&id=4687c7ba"
import script from "./bRadioInputValidation.ts?vue&type=script&lang=ts&external"
export * from "./bRadioInputValidation.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports